import { AxMachineModel } from './AxMachineModel';

export interface IAxMachineModels {
    /**
     * Date of latest changes on api side
     */
    date: string;
    /**
     * List of machine models
     */
    machineModels?: AxMachineModel[];
}

export class AxMachineModels implements IAxMachineModels {
    public date: string;
    public machineModels?: AxMachineModel[];

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IAxMachineModels);
    constructor(obj?: any) {
        this.date = obj && obj.date != null && obj.date.length > 0 ? obj.date : undefined;

        if (obj && obj.machineModels !== undefined) {
            this.machineModels = [];
            obj.machineModels.forEach((machineModel: AxMachineModel) => {
                if (this.machineModels) {
                    this.machineModels.push(new AxMachineModel(machineModel));
                }
            });
        } else if (obj && obj.axMachineModels !== undefined) {
            this.machineModels = [];
            obj.axMachineModels.forEach((machineModel: AxMachineModel) => {
                if (this.machineModels) {
                    this.machineModels.push(new AxMachineModel(machineModel));
                }
            });
        }
    }
}
